import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

import Header from '../Header';
import Footer from '../Footer';
import Toaster from '../Toaster/Toaster';
import WorkerRequestModal from '../WorkerRequestModal/WorkerRequestModal';
import ConsentGate from '../ConsentGate/ConsentGate';
import AppSmartBanner from '../AppSmartBanner';

import history from '../../history';

import SocketContext from '../../core/socketNotifications/SocketContext';
// external-global styles must be imported in your JS.
import normalizeCss from 'normalize.css';
import s from './Layout.css';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    // Set by the home route when the redesigned homepage (home-v2) renders: the header then
    // hides its duplicate mobile CTA row. Nothing else reads it.
    isHomeV2: PropTypes.bool,
  };

  render() {
    const { isBottomBanner, companyMode, isHomeV2 } = this.props;
    return (
      <>
        {/* A11Y (WCAG 2.1 AA 2.4.1 Bypass Blocks): skip-to-content link, visually
            hidden until keyboard-focused, jumps past the header nav to <main>. */}
        <a href="#main-content" className={s.skipLink}>Skip to main content</a>
        <Toaster />
        <WorkerRequestModal />
        <ConsentGate />
        <SocketContext.Consumer>
          {
            socket => (
              <Header location={history?.location?.pathname} socket={socket} companyMode={companyMode} isHomeV2={!!isHomeV2} />
            )
          }
        </SocketContext.Consumer>
        <main id="main-content" className='homePageBody'>{this.props.children}</main>
        <Footer isBottomBanner={isBottomBanner} />
        <AppSmartBanner />
      </>
    );
  }
}

export default withStyles(normalizeCss, s)(Layout);
